<itl-wizard-page
  class="wizard-page"
  [isSinglePage]="true"
  [pageTitleTransPath]="'kim.recipientSearch.filter.title'"
  [pageIsValid]="true"
  (doneClicked)="done()"
  (cancelClicked)="cancel()"
>
  <div class="page">
    <div class="content">
      <itl-text
        name="street"
        [title]="'kim.recipientSearch.filter.street' | translate"
        [formControl]="form.controls.street"
        icon="alberta-place"
        [placeholder]="'kim.recipientSearch.filter.street_placeholder' | translate"
      >
      </itl-text>
      <itl-text
        name="postalCode"
        [title]="'kim.recipientSearch.filter.postalCode' | translate"
        [formControl]="form.controls.postalCode"
        icon="alberta-place"
        [placeholder]="'kim.recipientSearch.filter.postalCode_placeholder' | translate"
      >
      </itl-text>
      <itl-text
        name="locality"
        [title]="'kim.recipientSearch.filter.locality' | translate"
        [formControl]="form.controls.locality"
        icon="alberta-place"
        [placeholder]="'kim.recipientSearch.filter.locality_placeholder' | translate"
      >
      </itl-text>
    </div>
    <div class="button-container">
      <itl-button class="deleteButton" expand="block" (click)="resetFilter()">
        {{ 'kim.recipientSearch.filter.reset' | translate }}
      </itl-button>
    </div>
  </div>
</itl-wizard-page>
